import { Link } from "react-router-dom";
import logo from "../../assets/img/trini-talk-bot-big.svg";

const TyC = () => {
  document.title = "Términos y Condiciones | Trini Talkbot";
  return (
    <>
      <div className="mx-md-5 mx-3" style={{ backgroundColor: "#f5f5f5" }}>
        <div className="djaCenter my-3">
          <Link to="/home">
            <img
              src={logo}
              alt="trini logo"
              className="imageLogo"
              onClick={() => {
                location.href = "https://trinitalkbot.com/";
              }}
              style={{ cursor: "pointer" }}
            />
          </Link>
        </div>
        <h2>
          <b>
            Términos y Condiciones de Uso del chatbot con IA en modalidad SaaS
          </b>
        </h2>
        <div className="my-4">
          <h3 style={{ color: "#c02972" }}>1. Descripción del servicio </h3>
          <p>
            El chatbot con IA en modalidad SaaS es un servicio proporcionado por
            Trini Talkbot que permite a los clientes utilizar un chatbot
            inteligente para interactuar con los usuarios de su sitio web y
            otros canales de comunicación especificados oportunamente. El
            chatbot con IA en modalidad SaaS se proporciona a los clientes como
            un servicio alojado y accesible a través de Internet.
          </p>
        </div>
        <div className="my-4">
          <h3 style={{ color: "#c02972" }}>
            2. Licencia y restricciones de uso
          </h3>
          <p>
            Al utilizar el chatbot con IA en modalidad SaaS, usted acepta los
            términos de la licencia y restricciones de uso que se establecen en
            este documento. La licencia le otorga el derecho no exclusivo, no
            transferible y limitado de utilizar el servicio del chatbot con IA
            en modalidad SaaS durante el plazo de su suscripción. Usted se
            compromete a no modificar, adaptar, traducir, sublicenciar, vender,
            alquilar o distribuir el servicio del chatbot con IA en modalidad
            SaaS a terceros.
          </p>
        </div>
        <div className="my-4">
          <h3 style={{ color: "#c02972" }}>3. Propiedad intelectual</h3>
          <p>
            Los derechos de propiedad intelectual, incluidos los derechos de
            autor, marcas comerciales, patentes y otros derechos de propiedad
            intelectual relacionados con el chatbot con IA en modalidad SaaS,
            son propiedad exclusiva de Trini Talkbot. Al utilizar el servicio
            del chatbot con IA en modalidad SaaS, usted no adquiere ningún
            derecho de propiedad intelectual sobre el mismo.
          </p>
        </div>
        <div className="my-4">
          <h3 style={{ color: "#c02972" }}>4. Confidencialidad</h3>
          <p>
            Usted se compromete a mantener la confidencialidad del chatbot con
            IA en modalidad SaaS y a no divulgar ninguna información
            confidencial a terceros. La información confidencial incluye, entre
            otros, el código fuente, los algoritmos y los datos del chatbot con
            IA en modalidad SaaS.
          </p>
        </div>
        <div className="my-4">
          <h3 style={{ color: "#c02972" }}>5. Responsabilidades del cliente</h3>
          <p>
            Usted es responsable de garantizar que el uso del chatbot con IA en
            modalidad SaaS se ajuste a todas las leyes, regulaciones y normas
            aplicables. Además, usted es responsable de garantizar que los
            usuarios finales del chatbot con IA en modalidad SaaS cumplan con
            estos términos y condiciones.
          </p>
        </div>
        <div className="my-4">
          <h3 style={{ color: "#c02972" }}>6. Limitación de responsabilidad</h3>
          <p>
            En ningún caso Trini Talkbot será responsable de cualquier daño
            indirecto, especial, incidental o consecuente que surja del uso o la
            imposibilidad de utilizar el chatbot con IA en modalidad SaaS.
          </p>
        </div>
        <div className="my-4">
          <h3 style={{ color: "#c02972" }}>7. Vigencia y terminación</h3>
          <p>
            La suscripción al chatbot con IA en modalidad SaaS tiene una
            vigencia determinada por el período de tiempo especificado en su
            contrato de suscripción. La suscripción se renovará automáticamente
            a menos que usted cancele la suscripción. Trini Talkbot se reserva
            el derecho de terminar su suscripción al chatbot con IA en modalidad
            SaaS si incumple alguno de los términos y condiciones establecidos
            en este documento.
          </p>
        </div>
        <div className="my-4">
          <h3 style={{ color: "#c02972" }}>8. Privacidad</h3>
          <p>
            Nuestra aplicación recopila información del usuario como nombre y
            apellido, contacto (correo electrónico y teléfono), información de
            su empresa en caso de corresponder y navegabilidad dentro de nuestra
            aplicación para fines de estadísticas de uso y acciones de
            marketing. En ningún caso vendemos ni compartimos dicha información
            con terceros, y cualquier usuario puede solicitar que se eliminen
            sus registros. Al utilizar nuestra aplicación, los usuarios aceptan
            que se recopile y use su información de acuerdo con los términos de
            esta política de privacidad. La presente cláusula se complementa con
            la política de privacidad de datos de la empresa.
          </p>
        </div>
        <div className="my-4 mb-5">
          <h3 style={{ color: "#c02972" }}>9. Modificaciones</h3>
          <p>
            Trini Talkbot se reserva el derecho de modificar los términos y
            condiciones de uso del chatbot con IA en modalidad SaaS en cualquier
            momento.
          </p>
        </div>
      </div>
      <div className="mx-md-5 mx-3">
        <h2>
          <b>Política de Privacidad de Datos de Trini Talkbot</b>
        </h2>
        <div className="my-4">
          <p>
            El presente documento regula la políticas internas de protección de
            datos personales de Trini Talkbot y engloba los aspectos más
            importantes respecto a la correcta gestión y protección de los datos
            de carácter personal.
          </p>
        </div>
        <div className="my-4">
          <h3 style={{ color: "#c02972" }}>1. Objetivos</h3>
          <p>
            Los principales objetivos de la presente Política de Privacidad de
            Datos son:
          </p>
          <ul style={{ padding: "5px 0px 0px 35px" }}>
            <li>
              Asegurar que toda la información personal en custodia de Trini
              Talkbot, esté adecuadamente protegida contra amenazas.
            </li>
            <li>
              Asegurar que los empleados de Trini Talkbot tengan pleno
              conocimiento de las implicaciones contractuales, legales o
              reglamentarias de cualquier incumplimiento de privacidad.
            </li>
            <li>
              Asegurar que todos los terceros que recopilan, almacenan y
              procesan información personal en nombre de Trini Talkbot brinden
              una protección de datos adecuada.
            </li>
            <li>
              Asegurar que se cumplan las reglamentaciones y contratos
              aplicables en relación con el mantenimiento de la privacidad, la
              protección y la transferencia fronteriza de información personal.
            </li>
          </ul>
        </div>
        <div className="my-4">
          <h3 style={{ color: "#c02972" }}>2. Términos y definiciones</h3>

          <ul style={{ padding: "5px 0px 0px 35px" }}>
            <li>
              Anonimizar: Procesar una recopilación de datos o información
              personal de modo que una persona física no pueda identificarse
              sobre la base de la recopilación de datos o información.
            </li>
            <li>
              Interesado: Individuo vivo sobre la cual la información personal
              es procesada por o en nombre de Trini Talkbot o de un Tercero
              responsable de datos personales.
            </li>
            <li>
              Datos Personales o información personal: Cualquier información que
              se relacione con una persona física o jurídica, que directa o
              indirectamente, en combinación con otra información disponible, es
              capaz de identificar a dicha persona.
            </li>
            <li>
              Terceros: Todas las entidades externas – incluidos, entre otros,
              proveedores, distribuidores, proveedores de servicio y socios –
              que tienen acceso a activos de información de Trini Talkbot,
              sistemas de información o que transmiten información personal de
              ellos.
            </li>
            <li>
              Terceros responsables de datos personales. Todas las entidades
              externas – incluidos, entre otros, proveedores, distribuidores,
              proveedores de servicio y clientes autorizados a procesar datos
              personales por personas físicas o jurídicas.
            </li>
          </ul>
        </div>
        <div className="my-4">
          <h3 style={{ color: "#c02972" }}>3. Principios</h3>
          <p>
            En el tratamiento de los datos personales, Trini Talkbot adopta
            acciones destinadas a preservar los siguientes principios básicos:
          </p>
          <p className="mt-2">
            <b>Principio de licitud</b>
          </p>
          Trini Talkbot adoptará las acciones necesarias para garantizar que los
          datos personales que recabe, almacene y procese de los Interesados
          sean tratados de manera lícita y leal. Para ello observará con
          particular atención:
          <ol type="A" style={{ padding: "5px 0px 0px 35px" }}>
            <li>
              la obtención del consentimiento del interesado o, en su caso, la
              existencia de cualquier otra condición de licitud de tratamiento
              prevista en la legislación aplicable.
            </li>
            <li>
              la necesidad del tratamiento y la finalidad legítima del mismo.
              Los datos personales serán recogidos con fines legítimos, y no
              serán tratados ulteriormente de manera incompatible con dichos
              fines.
            </li>
          </ol>
          <p className="mt-2">
            <b>Principio de transparencia</b>
          </p>
          Trini Talkbot adoptará las medidas necesarias para garantizar que se
          les facilite a los Interesados información fácilmente accesible e
          inteligible sobre los datos personales que recabe, almacene y procese.
          <br />
          Entre otras medidas, se proveerá a todos los Interesados la siguiente
          información:
          <ol style={{ padding: "5px 0px 0px 35px" }}>
            <li>Tipo de información que se recoge.</li>
            <li>Cómo se recoge la información.</li>
            <li>Finalidad de la recogida de la información.</li>
            <li>
              Plazo y condiciones de conservación de los datos personales.
            </li>
            <li>Condiciones de cesión de la información.</li>
          </ol>
          <p className="mt-2">
            <b>Principio de compromiso con los derechos del interesado</b>
          </p>
          Trini Talkbot debe ofrecer a los Interesados herramientas y/o
          procedimientos claros y sencillos para garantizar y asegurar el
          correcto ejercicio de los derechos del Interesado según el
          ordenamiento jurídico aplicable, tales como el derecho de acceso, de
          rectificación, de supresión, de oposición, el derecho a retirar el
          consentimiento en cualquier momento y el derecho a presentar
          reclamaciones. <br />
          Trini Talkbot garantiza a los Interesados los siguientes derechos:
          <ol type="A" style={{ padding: "5px 0px 0px 35px" }}>
            <li>
              Derecho de acceso: Es el derecho del Interesado a obtener
              confirmación de si Trini Talkbot está tratando o no sus datos
              personales y, en caso afirmativo, obtener información sobre sus
              datos concretos de carácter personal y del tratamiento que Trini
              Talkbot haya realizado o realice, así como, entre otra, de la
              información disponible sobre el origen de dichos datos.
            </li>
            <li>
              Derecho de rectificación: Es el derecho del Interesado a que se
              modifiquen sus datos personales que resulten ser inexactos o,
              teniendo en cuenta los fines del tratamiento, incompletos.
            </li>
            <li>
              Derecho de supresión (&quot;el derecho al olvido&quot;): Es el
              derecho del interesado, siempre que la legislación vigente no
              establezca lo contrario, a obtener la supresión de sus datos
              personales cuando estos ya no sean necesarios para los fines para
              los cuales fueron recogidos o tratados; a retirar su
              consentimiento al tratamiento si este no cuenta con otra base
              legal; a oponerse al tratamiento si no existe otro motivo legítimo
              para continuar con el mismo.
            </li>
          </ol>
          <p className="mt-2">
            <b>Principio de limitación del plazo de conservación</b>
          </p>
          Trini Talkbot no conservará los datos personales del Interesado más
          allá de los plazos en los que pueda estar justificado de acuerdo con
          la legislación aplicable de cada juridicción.
          <p className="mt-2">
            <b>Principio de seguridad del tratamiento</b>
          </p>
          Trini Talkbot, en cualquiera de las fases del ciclo del tratamiento,
          aplicará las medidas técnicas y organizativas apropiadas para
          garantizar un nivel de seguridad adecuado al riesgo al que los datos
          de carácter personal puedan estar expuestos y en todo caso, de
          conformidad con las medidas de seguridad establecidas en el
          ordenamiento jurídico vigente en cada uno de los países y/o regiones
          en los que opera y la normativa interna de Seguridad. Si en algún
          momento esta seguridad se ve comprometida, Trini Talkbot actuará de
          forma rápida y responsable informando a los interesados sobre la
          situación acaecida. <br />
          Asimismo, Trini Talkbot protegerá en todo momento el carácter
          confidencial de los datos de los Interesados, de conformidad con la
          normativa interna de clasificación y tratamiento de laInformación.{" "}
          <br />
          En la medida de lo posible, Trini Talkbot recibirá de los terceros
          responsables de datos personales datos anonimizados.
        </div>
        <div className="my-4">
          <h3 style={{ color: "#c02972" }}>
            4. Condiciones para el consentimiento
          </h3>
          <p>
            Trini Talkbot facilitará a los interesados una información clara y
            transparente sobre el uso y almacenamiento que hace de sus datos
            personales, de forma que éstos puedan consentir deforma libre,
            específica, informada e inequívoca sobre el tratamiento que de los
            mismos se haya de efectuar.
          </p>
        </div>
        <div className="my-4">
          <h3 style={{ color: "#c02972" }}>
            5. Prácticas de Seguridad para Privacidad
          </h3>
          <ul style={{ padding: "5px 0px 0px 35px" }}>
            <li>
              La política y los procedimientos de seguridad de la información de
              Trini Talkbot se documentan e implementan para garantizar la
              seguridad razonable de la información personal recopilada,
              almacenada, utilizada, transferida y dispuesta por Trini Talkbot.
            </li>
            <li>
              Trini Talkbot establece procedimientos que mantienen la seguridad
              física y lógica de la información personal.
            </li>
            <li>
              Trini Talkbot establece y mantiene protocolos y procedimientos de
              respuesta a incidentes de seguridad relacionados con datos
              personales o prácticas de privacidad.
            </li>
          </ul>
        </div>
        <div className="my-4">
          <h3 style={{ color: "#c02972" }}>
            6. Divulgación a Terceros y Transferencias Externas
          </h3>
          <ul style={{ padding: "5px 0px 0px 35px" }}>
            <li>
              La información personal se divulgará a terceros solo para fines
              comerciales legítimos e identificados, previamente deberá
              obtenerse el consentimiento de los interesados, a menos que una
              ley o reglamento permita o exija lo contrario.
            </li>
            <li>
              Cuando sea razonablemente posible, Trini Talkbot se asegurará de
              que los terceros encargados de recopilar, almacenar o procesar la
              información personal en nombre de Trini Talkbot disponen de:
              <ul style={{ padding: "5px 0px 0px 35px" }}>
                <li>
                  Acuerdos firmados para proteger la información personal de
                  acuerdo con la Política de Privacidad de Datos de Trini
                  Talkbot o medidas implementadas según lo prescrito por la ley;
                </li>
                <li>
                  Acuerdos de confidencialidad firmados o acuerdos que incluyen
                  cláusulas de privacidad en el contrato; y
                </li>
                <li>
                  Procedimientos establecidos para cumplir con los términos de
                  su acuerdo con Trini Talkbot para proteger la información
                  personal.
                </li>
              </ul>
            </li>
            <li>
              La información personal puede ser transferida fuera del lugar
              donde Trini Talkbot realiza el almacenamiento o procesamiento, en
              cualquiera de los siguientes casos:
              <ul style={{ padding: "5px 0px 0px 35px" }}>
                <li>
                  El individuo ha dado su consentimiento para la transferencia
                  de información.
                </li>
                <li>
                  La transferencia es necesaria para la ejecución de un contrato
                  entre el Interesado y Trini Talkbot.
                </li>
                <li>
                  La transferencia es necesaria o requerida legalmente por
                  razones importantes de interés público o para el
                  reconocimiento, el ejercicio o la defensa de un derecho en un
                  procedimiento judicial.
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div className="my-4">
          <h3 style={{ color: "#c02972" }}>
            7. Transferencia Internacional de datos
          </h3>
          <p>
            La información entregada por los Interesados puede ser transferida
            internacionalmente a a terceros para su tratamiento de acuerdo con
            los requisitos queestablezca la legislación aplicable en cada país
            y/o región, y a los acuerdos internacionales, donde se realice la
            transferencia.
          </p>
        </div>
        <div className="my-4">
          <h3 style={{ color: "#c02972" }}>
            8. Privacidad en la cadena de suministro
          </h3>
          <p>
            Trini Talkbot, asegurará contractualmente que cualquier proveedor
            que actúe bajo su autoridad y tenga acceso a datos personales de los
            Interesados de su titularidad, sólo pueda tratar dichos datos
            siguiendo sus instrucciones y, en todo caso, de forma segura
            mediante la adopción de las medidas de seguridad técnicas y
            organizativas necesarias y el cumplimiento íntegro del ordenamiento
            jurídico y normativa interna aplicable. <br />
            Así, Trini Talkbot priorizará la elección de aquellos proveedores
            que garanticen el cumplimiento de la legislación de protección de
            datos aplicable al tratamiento encomendado y, además, la presente
            política.
          </p>
        </div>
        <div className="my-4 mb-5">
          <h3 style={{ color: "#c02972" }}>
            9. Requerimientos de autoridades competentes
          </h3>
          <p>
            Trini Talkbot está sujeta a los entornos jurídicos en los que opera,
            por lo que debe, en circunstancias excepcionales y siempre
            expresamente previstas en las leyes nacionales, dar respuesta a
            requerimientos de las autoridades competentes relativos a
            determinada información sobre las comunicaciones de sus clientes y/o
            usuarios.
          </p>
        </div>
      </div>
      <div
        className="row footerLogin"
        style={{ position: "relative", width: "100%" }}
      >
        <div className="col-md-12">
          {new Date().getFullYear()} - TRINI Talkbot ® - Chatbot con
          Inteligencia Artificial
        </div>
      </div>
    </>
  );
};

export default TyC;
